import React, { useContext, useState } from 'react';
import { Box, Icon } from '@tonic-ui/react';
import { css, Global } from '@emotion/react';

import HeroBanner from './hero-banner';
import {
  CloudVideoContent,
  CustomersCarousel,
  SecurityConcernsSection,
  ExploreResources,
} from '../../components/public-landing-page';
import NotificationBanner from '../../components/notification-banner/notification-banner';
import { AuthContext } from '../../context/AuthContext';
import { useMarketplaceDetails } from '../../hooks/useMarketplaceDetails';
import { copyToClipboard, isGovCloudRegion } from '../../utils/helpers';
import { Footer } from '../../components/footer';
import BottomCTASection from '../../components/public-landing-page/bottom-cta-section/bottom-cta-section';
import { MaintenanceNoticeBanner } from '../../components/maintenance-notice-banner';

const PublicLanding = () => {
  const { eventDistributor, hasRequestErrors } = useContext(AuthContext);
  const [copySuccess, setCopySuccess] = useState(false);
  const [showBanner, setShowBanner] = useState({
    confirmationNotice: false,
    message: '',
  });
  const { marketplaceProvider = '', marketplaceToken = '' } = useMarketplaceDetails();
  const [sourceAccountIntegrationConfig] = useState(
    JSON.parse(localStorage.getItem('C1C_SourceAccountIntegrationRequest') || 'null')
  );
  const updateBannerBannerState = (updatedState) =>
    setShowBanner((prevState) => ({ ...prevState, ...updatedState }));

  return (
    <Box backgroundColor="white">
      <Global
        styles={css`
          h1,
          h2,
          h3 {
            font-family: 'Interstate', Arial, 'Helvetica Neue', Helvetica, sans-serif;
            margin: 0;
          }
        `}
      />
      <MaintenanceNoticeBanner />
      {marketplaceToken !== '' ? (
        <NotificationBanner
          name="marketplace-info"
          severity="info"
          backgroundColor="yellow:50"
          shouldOpen={true}
          showCloseButton={true}
          width="100%"
          bannerText={`loginView.marketplaceBannerText.${marketplaceProvider}`}
          bannerButtonTxt={
            copySuccess
              ? 'loginView.copyToClipboardSuccessMsg'
              : 'loginView.marketPlaceBannerBtnText'
          }
          bannerButtonIcon={
            copySuccess ? <Icon icon="check-bold" color="green:50" marginRight={10}></Icon> : <></>
          }
          clickHandler={async () => setCopySuccess(await copyToClipboard(window.location.href))}
        />
      ) : null}
      {sourceAccountIntegrationConfig && (
        <NotificationBanner
          name="sourceaccount-info"
          severity="info"
          backgroundColor="yellow:50"
          shouldOpen={true}
          showCloseButton={true}
          width="100%"
          bannerText={`loginView.sourceAccountBannerText.${sourceAccountIntegrationConfig?.sourceAccountIntegrationProvider}`}
        />
      )}
      {hasRequestErrors?.error && (
        <NotificationBanner
          name="error-info"
          severity="error"
          shouldOpen={true}
          showCloseButton={true}
          width="100%"
          bannerText={`errorMessaging.title`}
        />
      )}
      {showBanner.confirmationNotice && (
        <NotificationBanner
          name="confirmation-notice"
          severity="warning"
          showCloseButton={true}
          shouldOpen={showBanner.confirmationNotice}
          bannerText="resendConfirmation.bannerTitle"
          bannerButtonTxt="resendConfirmation.bannerBtn"
          clickHandler={() =>
            eventDistributor.dispatch({
              type: 'NAVIGATE_APP',
              appName: 'resend-confirmation',
            })
          }
        />
      )}
      <Box marginBottom="64px">
        <HeroBanner showAlertBanner={updateBannerBannerState} />
      </Box>
      <Box marginBottom="80px">
        <SecurityConcernsSection />
      </Box>
      {!isGovCloudRegion && (
        <>
          <Box marginBottom="247px">
            <CustomersCarousel />
          </Box>
          <Box marginBottom="125px">
            <CloudVideoContent />
          </Box>
        </>
      )}
      <Box marginBottom="141px">
        <ExploreResources />
      </Box>
      {isGovCloudRegion && <BottomCTASection />}
      <Footer />
    </Box>
  );
};

PublicLanding.displayName = 'PublicLanding';

export default PublicLanding;
